import { z } from 'zod'
import { OTP_LENGTH } from '@web/screens/auth/flow'

export const emailFormSchema = z.object({
	email: z.string().trim().min(1, 'Enter your work email.').pipe(z.email('That does not look like an email address.')),
})

export type EmailFormValues = z.infer<typeof emailFormSchema>

export const otpFormSchema = z.object({
	code: z.string().regex(new RegExp(`^\\d{${OTP_LENGTH}}$`), 'Enter every digit of the code.'),
})

export type OtpFormValues = z.infer<typeof otpFormSchema>
